import { render, staticRenderFns } from "./GangaoRecruitstudents.vue?vue&type=template&id=86014ef0&scoped=true"
import script from "./GangaoRecruitstudents.vue?vue&type=script&lang=js"
export * from "./GangaoRecruitstudents.vue?vue&type=script&lang=js"
import style0 from "./GangaoRecruitstudents.vue?vue&type=style&index=0&id=86014ef0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86014ef0",
  null
  
)

export default component.exports